<div class="container">
  <main>
    <div id="details" class="clearfix">
      <div id="client">
        <div class="to">ORDEN A:</div>

        <label for="producto">Cliente</label>

        {{ nombre_cliente }}

        <div class="address">
          <br />
          <label>NIT/CI: {{ nit }}</label>
        </div>
        <div class="email">
          <label>Direccion: {{ direccion }}</label>
        </div>
      </div>
      <div id="invoice">
        <h1>VENTA - {{ venta_id }} del pedido {{ orden_id }}</h1>
        <div class="date">
          Fecha de pedido:
          {{ fecha_pedido | date: 'dd/MM/yyyy' }}
        </div>
        <div class="date">
          Fecha de Entrega:
          {{ fecha_entrega | date: 'dd/MM/yyyy' }}
        </div>
      </div>
    </div>

    <br />
    <div>
      <table style="font-size: 10px;" class="table" border="0" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th class="no">#</th>
            <th colspan="2" class="desc">DESCRIPCION DEL PRODUCTO</th>
            <th class="unit">U.M.</th>
            <th class="unit">CANTIDAD</th>
            <th class="unit">PRECIO</th>
            <th class="total">TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let creds of list; let i = index">
            <td class="no">{{ i + 1 }}</td>
            <td colspan="2" class="desc">
              {{ creds.nombre_producto }}
            </td>
            <td class="qty">
              {{ creds.unidad }}
            </td>
            <td class="qty">
              {{ creds.cantidad }}
            </td>

            <td class="qty">
              {{ creds.precio }}
            </td>
            <td class="">
              {{ creds.cantidad * creds.precio | number: '1.2-2' }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4"></td>
            <td colspan="2">SUBTOTAL</td>
            <td class="text-left">
              {{ totalSum | currency: 'BOB':'symbol-narrow':'1.2-2' }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <br />
    <div class="row">
      <div class="col-md-3">
        Tipo de pago:
        {{ pago }}
      </div>
      <div class="col-md-3">
        Monto Inicial:
        {{ monto }}
      </div>
    </div>
    <br />

    <div class="row">
      <form [formGroup]="formPago2">
        <div class="col-md-12">
          <div formArrayName="pagos2">
            <div
              *ngFor="let pagos of formData2.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="row">
                <div class="col-md-1">Pago {{ i + 1 }}</div>
                <div class="col-md-3">
                  <input disabled
                    type="date"
                    formControlName="fecha"
                    class="form-control"
                  />
                </div>
                <div class="col-md-2">
                  <input disabled
                    type="number"
                    formControlName="monto"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  <input disabled
                    type="date"
                    formControlName="proximo_pago"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3 text-right">
                  <a
                    class="btn btn-danger"
                    style="color:white;"
                    (click)="eliminarPagoDB(pagos)"
                  >
                    Eliminar Pago</a
                  >
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="row">
      <div class="col-md-5 pagado text-right">
        PAGADO:
        {{ totalPagado | currency: 'BOB':'symbol-narrow':'1.2-2' }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-info" (click)="nuevoPago()">Agregar Pago</button>
      </div>
    </div>
    <div class="row">
      <form [formGroup]="formPago">
        <br />

        <div class="col-md-12">
          <div formArrayName="pagos">
            <div
              *ngFor="let pagos of formData.controls; let i = index"
              [formGroupName]="i"
            >
              <div class="row">
                
                <div class="col-md-4">
                  Pago
                  <input
                    type="date"
                    formControlName="fecha"
                    class="form-control"
                  />
                </div>
                <div class="col-md-3">
                  Monto
                  <input
                    type="number"
                    formControlName="monto"
                    class="form-control"
                  />
                </div>
                <div class="col-md-4">
                  Próximo pago
                  <input
                    type="date"
                    formControlName="proximo_pago"
                    class="form-control"
                  />
                </div>
                <div class="col-md-1 text-right">
                  <a
                    class="btn btn-danger"
                    style="color:white;"
                    (click)="eliminarPago(i)"
                  >
                    x</a
                  >
                </div>
              </div>
              <br />
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button
          type="button"
          class="btn btn-primary col-md-6"
          (click)="guardarPago()"
        >
          Registrar Pago
        </button>
      </div>
    </div>
    <br />
    <table>
      <tr>
        <td colspan="4"></td>
        <td colspan="2" class="pagado"></td>
        <td class="text-right pagado">
          DEUDA:
          {{ totalSum - totalPagado | currency: 'BOB':'symbol-narrow':'1.2-2' }}
        </td>
      </tr>
    </table>

    <div class="row">
      <div class="col-md-12">
        <button
          class="form-control btn btn-success"
          type="button"
          (click)="imprimirVenta()"
        >
          Imprimir Venta
        </button>
      </div>
    </div>
  </main>
</div>
